import React from "react";
import CampaignDetailPage from "../../pages/desktop/chatbot-recruiment/CampaignDetailPage";

const ChatPage = () => <CampaignDetailPage />;

export default ChatPage;
